"use client"

// Tiled diagonal "PREVIEW · GOONRU" watermark overlay for bounty script preview.
// Sits on top of the video player — pointer-events: none so playback is unaffected.
// Ruins screen recordings without blocking the viewing experience.

const WATERMARK_SVG = encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="200" height="120">
  <text
    x="50%" y="50%"
    dominant-baseline="middle"
    text-anchor="middle"
    transform="rotate(-30, 100, 60)"
    font-family="system-ui, sans-serif"
    font-size="13"
    font-weight="600"
    letter-spacing="2"
    fill="white"
    opacity="0.9"
  >PREVIEW · GOONRU</text>
</svg>
`)

export function PreviewWatermarkOverlay() {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 10,
        backgroundImage: `url("data:image/svg+xml,${WATERMARK_SVG}")`,
        backgroundRepeat: "repeat",
        opacity: 0.18,
      }}
    />
  )
}
